// Whether a filter field is named in a caller-supplied list — e.g. the
// `disabledFields` / `hiddenFields` a *ModalTableMultiselect's
// getFilterFields.tsx takes. A hidden field isn't rendered but still
// contributes its (usually prefilled) value to the query; a disabled one is
// rendered read-only.
export function isFilterFieldListed(
  fieldNames: string[] | undefined,
  name: string,
): boolean {
  return !!fieldNames?.includes(name);
}
